<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2023-01-11 11:20:22
 * @LastEditTime: 2023-01-11 11:26:41
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <div class="api-group">
      <ux-tooltip :content="$t('HT.doubleclick.copy')" placement="bottom">
        <span class="api-content" @dblclick="copyContent">{{ apikey }}</span>
      </ux-tooltip>
    </div>
</template>

<script>
export default {
  props: {
    apikey: {
      type: String,
      default: ''
    },
  },
  methods: {
    // 复制内容至剪切板
    copyContent() {
      let elInput = document.createElement('input');
      elInput.value = this.apikey;
      document.body.appendChild(elInput);
      // 选择对象
      elInput.select();
      // 执行浏览器复制命令
      document.execCommand('Copy');
      elInput.remove();
      this.$uxMessage.success(this.$t('HT.copy.success'));
    }
  },
};
</script>

<style lang="scss" scoped>
.api-content {
  cursor: context-menu;
}
</style>